import dateFormat from 'dateformat';

const futureDateCalculator = (date: string, addedMonths: string) => {
  const dateObj = new Date(date);
  dateObj.setMonth(dateObj.getMonth() + parseInt(addedMonths));
  return dateFormat(dateObj, 'mmm d, yyyy');
};

export default futureDateCalculator;
